import api from '../../../axios/axios-api'

export default {
  async fetchMisDatos({ rootState }, payload) {
    const params = {}
    const fichaId = Number(
      payload && Object.prototype.hasOwnProperty.call(payload, 'fichaId')
        ? payload.fichaId
        : rootState?.portalHome?.activePortalFichaId,
    )
    if (Number.isFinite(fichaId) && fichaId > 0) params.fichaId = fichaId
    const { data } = await api.get('Home/mis-datos', { params })
    return data
  },
  async saveMisDatos(_context, payload) {
    const { data } = await api.put('Home/mis-datos', payload)
    return data
  },
}
